import { render } from "./BaseActions.vue?vue&type=template&id=3c36d52e&scoped=true"
import script from "./BaseActions.vue?vue&type=script&lang=js"
export * from "./BaseActions.vue?vue&type=script&lang=js"

import "./BaseActions.vue?vue&type=style&index=0&id=3c36d52e&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c36d52e"]])

export default __exports__